var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "#999999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77996 2.16671L9.99996 5.38671V12.8334H1.99996V2.16671H6.77996ZM7.33329 0.833374H1.99996C1.26663 0.833374 0.666626 1.43337 0.666626 2.16671V12.8334C0.666626 13.5667 1.26663 14.1667 1.99996 14.1667H9.99996C10.7333 14.1667 11.3333 13.5667 11.3333 12.8334V4.83337L7.33329 0.833374ZM5.99996 8.83337C6.73329 8.83337 7.33329 8.23337 7.33329 7.50004C7.33329 6.76671 6.73329 6.16671 5.99996 6.16671C5.26663 6.16671 4.66663 6.76671 4.66663 7.50004C4.66663 8.23337 5.26663 8.83337 5.99996 8.83337ZM8.66663 11.12C8.66663 10.58 8.34663 10.1 7.85329 9.88671C7.28663 9.64004 6.65996 9.50004 5.99996 9.50004C5.33996 9.50004 4.71329 9.64004 4.14663 9.88671C3.65329 10.1 3.33329 10.58 3.33329 11.12V11.5H8.66663V11.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCard);
export default __webpack_public_path__ + "static/media/contactCard.d8509016.svg";
export { ForwardRef as ReactComponent };